import React from "react";

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-200/40 px-2 sm:px-4">
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-4xl
                      max-h-[95vh] flex flex-col">

        <div className="flex items-center justify-between px-4 py-1 border-b">
          <h2 className="text-lg sm:text-xl font-bold truncate">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✖
          </button>
        </div>

        <div className="px-4 py-1 sm:px-6 sm:py-3 overflow-y-auto flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
